<template style="">
  <div class="Game_a_type">

    <el-row :gutter="20">
      <el-col :span="20">
        <div class="grid-content bg-purple Game_a_type_left">
          <div class="Game_table">
            <table>



            </table>
          </div>
        </div>
      </el-col>

      <el-col :span="4">
        <div style="height: 100%;" class="grid-content bg-purple">
          <ul class="Game_a_type_right">

            <li>
              <h3 style="text-align: center;padding-top: 30px;color: rgba(201,162,88,1);">数字方格</h3>
              <p style="text-align: left;margin-left: 20px;margin-top: 15px; color: rgba(201,162,88,1);">难度：自定义</p>
              <p style="text-align: left;margin-left: 20px;margin-top: 15px; color: rgba(201,162,88,1);">状态：训练进行中</p>
              <p style="text-align: left;margin-left: 20px;margin-top: 15px; color: rgba(201,162,88,1);">错误：{{ myFaultCount }}</p>
            </li>

            <li>
              <h3 style="text-align: center;padding-top: 55px;color: rgba(201,162,88,1);">
                <p>剩余时间</p>
                <p style="font-size: 24px;color: red;margin-top: 20px;">{{ myTime }}</p>
              </h3>
            </li>

            <li>
              <p style="text-align: center;padding-top:50px;"><el-button type="primary" @click="Startover()">重新开始</el-button></p>
              <p style="text-align: center;margin-top: 20px;"><el-button type="primary">难度选择</el-button></p>
              <p style="text-align: center;margin-top: 20px;"><el-button type="primary">退出    </el-button></p>
            </li>

          </ul>
        </div>
      </el-col>
    </el-row>

  </div>
</template>
<script>
export default {
  data() {
    return {
      myFaultCount: '',//剩余数
      myTimeCount: 10, //总时间
      myTime: 0, //呈现时间
    }
  },
  mounted() {
    this.Time(this.myTimeCount);
  },
  methods: {
    Time(time) {//倒计时
      this.myTime = parseInt(time / 60) + '分' + time % 60 + '秒';
      let timer = setInterval(() => {
        this.myTime = parseInt(time / 60) + '分' + time % 60 + '秒';
        if (time > 0) {
          time--
        } else {
          clearTimeout(timer)
          this.submit()
        }
      }, 1000)
    },
    submit() {//提交函数
      // alert("提交函数")
    },
    
  }
}

</script>

<style>

  .Game_a_type{width: 100%;height: 100%;}
  .Game_a_type td{width: 40px;height: 40px;border: 1px saddlebrown solid;text-align: center;}
  .Game_table{height: 100%;width: 100%;position: relative;}
  /* .Game_a_type tr{float: left;} */
  .Game_a_type table{position: absolute;top: 0px;left: 0px;right: 0px;bottom: 0px;margin: auto;}
  .Game_a_type .el-row{height: 100%;}
  .Game_a_type .el-col-20{height: 100%;}
  .Game_a_type .el-col-4{height: 100%;}
  .Game_a_type_left{height: 100%;background-image: url('../../assets/div3_left1.png');background-size: 100% 100%;background-color: #C4E8DC;}
  .Game_a_type_right li{margin-top: 15px;}
  .Game_a_type_right{height: 100%;}
  .Game_a_type_right li:nth-child(1){height: 30%;background-image: url('../../assets/div3_right1.png');background-size: 100% 100%;margin-top: 0px;}
  .Game_a_type_right li:nth-child(2){height: 20%;background-image: url('../../assets/div3_right1.png');background-size: 100% 100%;}
  .Game_a_type_right li:nth-child(3){height: calc(50% - 25px);background-image: url('../../assets/div3_right1.png');background-size: 100% 100%;}
  .Game_table td{text-align: center;line-height: 40px;}
</style>
